"use client";

import { usePathname } from "next/navigation";
import { MotionConfig } from "framer-motion";
import Header from "@/app/components/Header";
import Footer from "@/app/components/Footer";

export default function ConditionalLayout({ children }) {
  const pathname = usePathname();

  // Hide main header/footer on docs pages or documentation sub-pages (not /documentation root)
  const isDocsPage = pathname?.startsWith("/docs");
  const isDocumentationSubPage =
    pathname?.startsWith("/documentation/") && pathname !== "/documentation";
  const hideMainChrome = isDocsPage || isDocumentationSubPage;

  return (
    <MotionConfig reducedMotion="user">
      {!hideMainChrome && <Header />}

      {/* MAIN CONTENT WITH RAILS - skipped for docs pages so their own layout can stretch freely */}
      {hideMainChrome ? (
        <>{children}</>
      ) : (
        <main className="site-rails">{children}</main>
      )}

      {/* FOOTER */}
      {!hideMainChrome && <Footer />}
    </MotionConfig>
  );
}
